<template>
    <div class="form-container">
        <div class="form-container">
            <el-form ref="livreurForm" label-position="left">
                <el-row type="flex">
                    <el-form-item label="CP" prop="data">
                        <el-input @input="calcul()" v-model="cp" />
                    </el-form-item>
                    <el-form-item label="Valeur HT">
                        <el-input @input="calcul()" v-model="valeurht" />
                    </el-form-item>
                    <el-form-item label="nb cols" prop="nbcols">
                        <el-input @input="calcul()" v-model="nbcols" />
                    </el-form-item>
                </el-row>
            </el-form>
            <div>{{ departement }} {{ message }}</div>
            <div>
                <b>
                    ( {{ colprix }} + {{ valeurht }} x {{ livreur.assurance }}
                    <span v-if="ismontagne"> + {{ livreur.taxmontagne }}</span>
                    ) x 1 + {{ livreur.taxgasoil }} = {{ prix }}€ht ({{
                        prixttc
                    }}€ttc)
                </b>
            </div>
            <div>
                ( forfait transp + valeurHT x assurance + taxe montagne ) x (1 +
                tax gasoil)
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "Livraisonprix",
    props: {
        livreur: {
            type: Object,
            default: () => {
                return {
                    nom: "Nouveau",
                    etat: "inactif",
                    assurance: 0.006,
                    taxmontagne: 18.3,
                    maxcol: null,
                    departement_id: null,
                    data: null,
                    cps_montagne: null,
                    tarifs: null
                };
            }
        },
        parent: {
            type: Object
        }
    },
    mounted() {
        this.calcul();
    },
    data() {
        return {
            cp: "04000",
            nbcols: "8",
            colprix: "",
            departement: "",
            message: "",
            valeurht: "99",
            ismontagne: false,
            prix: "",
            prixttc: ""
        };
    },
    methods: {
        calcul() {
            var departement_code = this.cp.substring(0, 2);
            this.message = "";
            if (departement_code.length == 2) {
                var tarif = this.livreur.tarifs.find(
                    tarif => tarif.code == departement_code
                );
                if (this.nbcols) {
                    var max =
                        this.nbcols <= 6
                            ? 6
                            : this.nbcols <= 12
                            ? 12
                            : this.nbcols <= 18
                            ? 18
                            : this.nbcols <= 24
                            ? 24
                            : false;
                    if (max) {
                        this.message = "tarif pour " + max + " cols";
                    } else {
                        this.message = "pas de tarif pour cette quantité";
                        this.colprix = null;
                    }
                }
                if (tarif && tarif.nom) {
                    this.departement = tarif.nom;
                    this.ismontagne =
                        tarif.cps_montagne.indexOf(this.cp) !== -1
                            ? true
                            : false;
                    this.message += this.ismontagne
                        ? " avec taxe montagne de " +
                          this.livreur.taxmontagne +
                          "€"
                        : " sans taxe montagne";
                    if (max) {
                        this.colprix = Number.parseFloat(
                            tarif.tarifs[max]
                        ).toFixed(2);
                    }
                    var taxmontagne = this.ismontagne
                        ? this.livreur.taxmontagne
                        : 0;
                    console.log(taxmontagne);
                    this.prix = Number.parseFloat(
                        (parseFloat(this.colprix) +
                            parseFloat(this.valeurht) *
                                parseFloat(this.livreur.assurance) +
                            parseFloat(taxmontagne)) *
                            (1 + parseFloat(this.livreur.taxgasoil))
                    ).toFixed(2);
                    this.prixttc = Number.parseFloat(this.prix * 1.2).toFixed(
                        2
                    );
                } else {
                    this.departement = "non trouvé";
                    this.colprix = null;
                }
            }
        }
    }
};
</script>
